const typeHints = {
  TextArea: 'textarea',
  Monetary: 'monetary',
  Contact: 'contact',
  Date: 'date',
};

export default typeHints;



// WEBPACK FOOTER //
// ./src/config/typeHints.js